// The TITLE of a sign-in route wrapper (pages/index.js `login` / `signin`)
// on a white-label host (ws crm review of 178bd1266; relman, vault.pr:
// 2,487 ms "Log in / Symbols" over the edge-stamped "Vault Partners").
//
//   el.call('authWrapperTitle', 'workspace.page.login')
//
// The wrapper and the shared sign-in page it mounts BOTH carry metadata, and
// helmet keeps whichever title was last written. So on a custom-domain host:
//   • a NAMED brand is there → no title here: the inner page owns
//     "Sign in / <org>";
//   • the brand is still LOADING (root.whitelabelBrand null) → no title: the
//     edge-stamped one stays — never "… / Symbols";
//   • the lookup settled with NO brand (whitelabelBrand false, written by
//     applyWhitelabelBrandLate) → the wrapper's own title, never an empty tab.
// A platform host (isCustomDomainHost false or not registered) keeps the
// wrapper's own title, unchanged. `function`, not an arrow: el.call binds
// `this` to the element.
export function authWrapperTitle(key) {
  const el = this
  const brand = el?.state?.root?.whitelabelBrand
  if (brand && brand.name) return undefined
  const fns = el?.context?.functions
  const customDomain =
    typeof fns?.isCustomDomainHost === 'function' && !!el.call('isCustomDomainHost')
  if (customDomain && brand == null) return undefined
  return el.call('polyglot', key)
}
